import React from "react";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import { useModalContext } from "../../contexts/ModalContext/context";
import type { SxProps, Theme } from "@mui/material";

interface IProps {
  title?: string;
  fullWidth?: boolean;
  onClose?: VoidFunction;
  withoutTopBorder?: boolean;
  actions?: React.ReactNode;
  containerSx?: SxProps<Theme>;
  contentSx?: SxProps<Theme>;
  maxWidth?: DialogProps["maxWidth"];
}

export const Modal: React.FC<IProps> = (props) => {
  const { isOpen, setIsOpen } = useModalContext();

  function handleClose() {
    if (props.onClose) {
      props.onClose();
    }

    setIsOpen(false);
  }

  return (
    <Dialog
      fullWidth={props.fullWidth}
      open={isOpen}
      onClose={handleClose}
      maxWidth={props.maxWidth}
      PaperProps={{ sx: props.containerSx }}
    >
      {props.title && <DialogTitle>{props.title}</DialogTitle>}
      <DialogContent
        sx={{
          p: 0,
          borderTop: (theme) => (props.withoutTopBorder ? 0 : `1px solid ${theme.palette.divider}`),
          ...props.contentSx,
        }}
      >
        {props.children}
      </DialogContent>
      {props.actions && <DialogActions sx={{ px: 3, pb: 2 }}>{props.actions}</DialogActions>}
    </Dialog>
  );
};

Modal.defaultProps = {
  maxWidth: "sm",
  withoutTopBorder: false,
};
